import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './AdminLogin.css';

// Importa la configurazione API
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/shop/backend/api' 
  : 'http://efwypvu.cluster021.hosting.ovh.net/shop/backend/api';

const AdminLogin = () => {
  const navigate = useNavigate();
  const publicUrl = process.env.PUBLIC_URL || '';
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      console.log('🔐 Tentativo di login con:', formData);
      
      const response = await fetch(`${API_BASE_URL}/auth.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(formData),
      });

      console.log('📡 Risposta ricevuta:', response.status, response.statusText);
      
      const data = await response.json();
      console.log('📋 Dati ricevuti:', data);

      if (!data.success) {
        console.error('❌ Login fallito:', data);
        throw new Error(data.message || 'Errore durante il login');
      }

      console.log('✅ Login riuscito! Reindirizzamento...');
      // Login riuscito, salva i dati admin e vai alla dashboard
      localStorage.setItem('admin_logged_in', 'true');
      localStorage.setItem('admin_data', JSON.stringify(data.data));
      navigate('/amministrazione/dashboard');
      
    } catch (err) {
      console.error('💥 Errore durante il login:', err);
      setError(err.message || 'Errore di connessione al server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="login-container">
        {/* Sezione Sinistra - Branding */}
        <div className="login-left">
          <img src={`${publicUrl}/logomuseo.png`} alt="Museo Stibbert" className="login-logo" />
          <h1>Amministrazione</h1>
          <p>Museo Stibbert Shop</p>
          <p className="subtitle">Gestisci prodotti, ordini e contenuti del tuo e-commerce</p>
        </div>

        {/* Sezione Destra - Form Login */}
        <div className="login-right">
          <h2>Accedi al Pannello</h2>
          
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
                placeholder="Inserisci username"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  placeholder="Inserisci password"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                  aria-label={showPassword ? 'Nascondi password' : 'Mostra password'}
                >
                  <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
            </div>

            {error && (
              <div className="error-message">
                ⚠️ {error}
              </div>
            )}

            <button 
              type="submit" 
              className="btn btn-primary btn-login"
              disabled={loading}
            >
              {loading ? 'Accesso in corso...' : 'Accedi'}
            </button>
          </form>

          <div className="login-footer">
            <Link to="/" className="back-link">
              ← Torna al sito
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;

